import { useState, useEffect } from 'react';
import { dashboardService } from '../../services';

export const QuickStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await dashboardService.getStats();
        setStats(data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      }
    };

    fetchStats();
  }, []);

  if (!stats) return null;

  return (
    <div className="quick-stats">
      <div className="stat-card">
        <div className="stat-value">{stats.modules?.active || 0}</div>
        <div className="stat-label">Active Modules</div>
      </div>
      {stats.users && (
        <>
          <div className="stat-card">
            <div className="stat-value">{stats.users.activeUsers || 0}</div>
            <div className="stat-label">Active Users</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.users.technicians || 0}</div>
            <div className="stat-label">Technicians</div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuickStats;
